import {RunningTime, RunningTimeType} from '@hconnect/common/types'
import {datetimeFormatter, timeFormatter} from '@hconnect/uikit/src/common'
import {TFunction} from 'i18next'
import moment from 'moment-timezone'

// TODO: deprecate this function and use getRunningTimeDuration instead
export const getRunningTimeData = (
  {beginTechnical, endTechnical, runningTimeType}: RunningTime,
  language: string,
  t: TFunction
): string => {
  if (!beginTechnical) return '-'

  const isDateSame = moment(beginTechnical).isSame(endTechnical, 'day')
  const startLabel = datetimeFormatter(beginTechnical, language)

  if (endTechnical?.isValid()) {
    const endLabel = isDateSame
      ? timeFormatter(endTechnical, language)
      : datetimeFormatter(endTechnical, language)
    return `${startLabel} - ${endLabel}`
  }

  const ongoingLabel =
    runningTimeType === RunningTimeType.STOPPED
      ? t('stackedBarChart.label.stillStopped')
      : t('stackedBarChart.label.stillRunning')
  return `${startLabel} - ${ongoingLabel}`
}

export const getRunningTimeDuration = ({
  beginUtc,
  endUtc,
  timezone,
  runningTimeType,
  language,
  translationFn
}: {
  beginUtc?: string
  endUtc?: string
  timezone: string
  runningTimeType?: RunningTimeType
  language: string
  translationFn: TFunction
}): string => {
  if (!beginUtc) return '-'

  const start = moment.utc(beginUtc).tz(timezone)
  const end = moment.utc(endUtc).tz(timezone)
  const isDateSame = start.isSame(end, 'day')
  const startLabel = datetimeFormatter(start, language, start.utcOffset())

  if (endUtc && moment(endUtc).isValid()) {
    const endLabel = isDateSame
      ? timeFormatter(end, language, end.utcOffset())
      : datetimeFormatter(end, language, end.utcOffset())
    return `${startLabel} - ${endLabel}`
  }

  if (runningTimeType) {
    const ongoingLabel =
      runningTimeType === RunningTimeType.STOPPED
        ? translationFn('stackedBarChart.label.stillStopped')
        : translationFn('stackedBarChart.label.stillRunning')
    return `${startLabel} - ${ongoingLabel}`
  }

  return `${startLabel} - ${translationFn('stackedBarChart.label.ongoing')}`
}
